












import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'
import User from '@/dto/User'

@Component({ inheritAttrs: false })
export default class UserAvatar extends Vue {
  @Prop({ type: Object })
  user: User

  get uniqueImage(): string {
    return this.user.avatar + '?' + new Date().getTime()
  }

  get fullName(): string {
    return `${this.user.lastName} ${this.user.firstName}`
  }

  get userInitials(): string {
    return `${this.user.lastName ? this.user.lastName[0] : ''}${
      this.user.firstName ? this.user.firstName[0] : ''
    }`.toUpperCase()
  }
}
